import { LANGUAGES } from 'config/constants/languages'
import { useRouter } from 'hooks/useRouter'
import theme from 'theme'
import { GridProps } from 'UIKit/Box/types'
import { PopperContentProps } from 'UIKit/Popper/typpes'
import { setCookie } from 'utils/cookie'
import { StyledLanguagePopupContainer } from '../style'
import LanguageItem from './LanguageItem'

const LanguageSelector: React.FC<PopperContentProps & GridProps> = ({ onDismiss, ...props }) => {
  const router = useRouter()

  const handleSelect = (code: string) => {
    setCookie('APP_LANG', code)
    const { pathname, query } = router
    router.push({ pathname, query }, '', { locale: 'en', unstable_skipClientCache: true })

    if (onDismiss) onDismiss()
  }

  return (
    <StyledLanguagePopupContainer
      gridTemplateColumns="1fr 1fr"
      background={theme.colors.background}
      mt="12px"
      {...props}
    >
      {LANGUAGES.map((item) => (
        <LanguageItem key={item.code} item={item} handleSelect={handleSelect} />
      ))}
    </StyledLanguagePopupContainer>
  )
}

export default LanguageSelector
